import gql from "graphql-tag";
import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import { accountFragment } from "@zapier/upsells/esm/fragments";
import { useCurrentAccountId } from "@zapier/upsells/esm/hooks";
export const currentAccountQuery = gql `
  query upsells_currentAccountQuery($accountId: Int!) {
    account(id: $accountId) {
      ...upsells_accountFragment
    }
  }
  ${accountFragment}
`;
export const useCurrentAccount = (props) => {
    const useQuery = (props === null || props === void 0 ? void 0 : props.useQuery) || defaultUseQuery;
    const { accountId } = useCurrentAccountId({ useQuery });
    const { data, error, loading: isLoading, } = useQuery(currentAccountQuery, {
        skip: !accountId,
        variables: {
            accountId,
        },
    });
    return {
        currentAccount: data === null || data === void 0 ? void 0 : data.account,
        error: error === null || error === void 0 ? void 0 : error.message,
        isLoading,
    };
};

// @zapier/upsells@8.0.3 (1de7a616e)
